import { IGQLApiError } from "../api.types"
import { PaybisKybStatusItem } from "../paybis-kyb-status/paybisKybStatus.types"

export enum PaybisKybTcStatus {
    ACCEPTED = "accepted",
    NOT_ACCEPTED = "not_accepted",
}

export type PaybisUpdateKybTcStatusData = {
    accessToken: string
    companyId: string
    tcStatus: PaybisKybTcStatus
}

export type PaybisUpdateKybTcStatusResponse = {
    data: {
        paybisUpdateKybTcStatus: PaybisKybStatusItem
    }
    errors?: IGQLApiError[]
}
